module.exports = __webpack_public_path__ + "img/to.0da693dc.svg";